import CopyToClipboard from "react-copy-to-clipboard";
import { Modal } from "react-bootstrap";
import { withIntl } from "../wrappers";
import { intlShape } from "../shapes";
import Column from "./Grid/Column";
import Row from "./Grid/Row";

type Props = {
  show?: boolean;
  title?: string;
  backdrop?: string;
  image?: string;
  message?: string | React.ReactElement;
  copyValues?: string;
  onCopyValue?: $TSFixMeFunction;
  showClose?: boolean;
  onSave?: $TSFixMeFunction;
  onClose?: $TSFixMeFunction;
  intl: intlShape;
};

export function CopySavedModal({
  show,
  title,
  message,
  image,
  showClose,
  onSave,
  copyValues,
  onCopyValue,
  onClose,
  backdrop,
  intl,
}: Props) {
  const modalHeader = (
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
  );

  const modalBody = (
    <Modal.Body>
      {image ? (
        <Row>
          <Column>{image && <img alt="device" src={image} />}</Column>
        </Row>
      ) : null}
      <Row>
        <Column>{message}</Column>
      </Row>
    </Modal.Body>
  );

  const renderCloseButton = showClose ? (
    <button
      id="button-close"
      type="button"
      className="btn btn-default"
      // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
      onClick={() => onClose()}
    >
      {intl.formatMessage({ id: "button.close" })}
    </button>
  ) : null;

  const modalFooter = (
    <Modal.Footer>
      <Row>
        <Column>
          <div className="btn-group justify-middle">
            {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
            <CopyToClipboard text={copyValues} onCopy={() => onCopyValue()}>
              <button
                id="button-copy"
                type="button"
                className="btn btn-primary"
              >
                {intl.formatMessage({ id: "button.copy" })}
              </button>
            </CopyToClipboard>
            <button
              id="button-save"
              type="button"
              className="btn btn-default"
              // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
              onClick={() => onSave()}
            >
              {intl.formatMessage({ id: "button.download" })}
            </button>
            {renderCloseButton}
          </div>
        </Column>
      </Row>
    </Modal.Footer>
  );

  return (
    <Modal
      show={show}
      // @ts-expect-error TS(2769) FIXME: No overload matches this call.
      onHide={onClose}
      restoreFocus={false}
      backdrop={backdrop}
    >
      {modalHeader}
      {modalBody}
      {modalFooter}
    </Modal>
  );
}

export default withIntl(CopySavedModal);
